import axios from 'axios';
import config from '../config';

export function fetchShift(id) {
  return axios.get(`${config.api}/shifts/${id}?token=${config.token}`);
}

export function submitShift(values) {
  const method = typeof values.id !== 'undefined' && values.id ? 'PUT' : 'POST';
  const idParam = typeof values.id !== 'undefined' && values.id ? `/${values.id}` : '';

  return axios.post(`${config.api}/shifts${idParam}?token=${config.token}`, Object.assign({}, values, {
    _method: method,
  }));
}

export function copyShift(shiftId, date) {
  return axios.post(`${config.api}/copy-shift/${shiftId}?token=${config.token}`, {
    date,
  });
}

export function addEmployeeToShift(employeeId, shiftId) {
  return axios.post(`${config.api}/add-to-shift/${shiftId}/${employeeId}?token=${config.token}`);
}

export function removeEmployeeFromShift(employeeId, shiftId) {
  return axios.post(`${config.api}/remove-from-shift/${shiftId}/${employeeId}?token=${config.token}`);
}



// WEBPACK FOOTER //
// ./src/api/shift.js